import { render, staticRenderFns } from "./workDeductionList.vue?vue&type=template&id=6f65c876&scoped=true"
import script from "./workDeductionList.vue?vue&type=script&lang=js"
export * from "./workDeductionList.vue?vue&type=script&lang=js"
import style0 from "./workDeductionList.vue?vue&type=style&index=0&id=6f65c876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65c876",
  null
  
)

export default component.exports